import React, { Component } from 'react';
import styled from 'styled-components';

const Container = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #0d1117;
  padding: 20px;
`;

const Card = styled.div`
  background: #1a2026;
  border: 1px solid #2d3748;
  border-radius: 16px;
  padding: 40px 32px;
  width: 100%;
  max-width: 400px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);
`;

const Logo = styled.div`
  text-align: center;
  margin-bottom: 28px;
  img {
    height: 50px;
  }
`;

const Title = styled.h2`
  color: #fff;
  text-align: center;
  margin-bottom: 8px;
  font-size: 22px;
  font-weight: 600;
`;

const Subtitle = styled.p`
  color: #6b7280;
  text-align: center;
  margin-bottom: 28px;
  font-size: 13px;
`;

const InputWrapper = styled.div`
  margin-bottom: 18px;
`;

const Label = styled.label`
  color: #9ca3af;
  font-size: 12px;
  font-weight: 500;
  display: block;
  margin-bottom: 6px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

const Input = styled.input`
  width: 100%;
  padding: 12px 14px;
  background: #0d1117;
  border: 1px solid #25ee89;
  border-radius: 8px;
  color: #fff;
  font-size: 14px;
  outline: none;
  transition: border-color 0.2s;
  box-sizing: border-box;

  &:focus {
    border-color: #25ee89;
    box-shadow: 0 0 0 2px rgba(37, 238, 137, 0.15);
  }

  &::placeholder {
    color: #4b5563;
  }
`;

const Button = styled.button`
  width: 100%;
  padding: 13px;
  background: ${props => props.disabled ? '#2d3748' : 'linear-gradient(135deg, #25ee89, #1dbf6f)'};
  color: ${props => props.disabled ? '#6b7280' : '#0d1117'};
  border: none;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 700;
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  margin-top: 8px;
  transition: all 0.2s;
  box-shadow: ${props => props.disabled ? 'none' : '0 4px 15px rgba(37, 238, 137, 0.3)'};

  &:hover:not(:disabled) {
    transform: translateY(-1px);
    box-shadow: 0 6px 20px rgba(37, 238, 137, 0.4);
  }
`;

const Message = styled.div`
  text-align: center;
  padding: 12px 14px;
  border-radius: 8px;
  margin-bottom: 18px;
  font-size: 13px;
  background: ${props => props.type === 'success' ? 'rgba(37, 238, 137, 0.1)' : 'rgba(244, 67, 54, 0.1)'};
  color: ${props => props.type === 'success' ? '#25ee89' : '#f44336'};
  border: 1px solid ${props => props.type === 'success' ? 'rgba(37, 238, 137, 0.2)' : 'rgba(244, 67, 54, 0.2)'};
`;

const BackLink = styled.a`
  display: block;
  text-align: center;
  color: #25ee89;
  margin-top: 20px;
  font-size: 13px;
  text-decoration: none;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
    color: #4dffa6;
  }
`;

const Spinner = styled.div`
  width: 32px;
  height: 32px;
  border: 3px solid #2d3748;
  border-top: 3px solid #25ee89;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
  margin: 0 auto 16px;

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

class ResetPassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      newPassword: '',
      confirmPassword: '',
      loading: true,
      submitting: false,
      tokenValid: false,
      message: '',
      messageType: '',
      success: false
    };
  }

  componentDidMount() {
    this.verifyToken();
  }

  getToken = () => {
    const path = window.location.pathname;
    const parts = path.split('/');
    return parts[parts.length - 1];
  }

  verifyToken = async () => {
    const token = this.getToken();
    try {
      const response = await fetch(`https://bkk07.com/user/verify-reset-token/${token}`);
      const data = await response.json();
      
      if (data.valid) {
        this.setState({ tokenValid: true, loading: false });
      } else {
        this.setState({ 
          tokenValid: false, 
          loading: false, 
          message: data.message || 'Invalid or expired reset link',
          messageType: 'error'
        });
      }
    } catch (err) {
      this.setState({ 
        tokenValid: false, 
        loading: false, 
        message: 'Unable to verify reset link. Please try again.',
        messageType: 'error'
      });
    }
  }

  handleSubmit = async (e) => {
    e.preventDefault();
    const { newPassword, confirmPassword } = this.state;

    if (!newPassword || !confirmPassword) {
      this.setState({ message: 'Please fill in all fields', messageType: 'error' });
      return;
    }

    if (newPassword.length < 6) {
      this.setState({ message: 'Password must be at least 6 characters', messageType: 'error' });
      return;
    }

    if (newPassword !== confirmPassword) {
      this.setState({ message: 'Passwords do not match', messageType: 'error' });
      return;
    }

    this.setState({ submitting: true, message: '' });

    try {
      const token = this.getToken();
      const response = await fetch('https://bkk07.com/user/reset-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, newPassword })
      });

      const data = await response.json();

      if (data.success) {
        this.setState({ 
          success: true, 
          message: 'Password reset successfully! You can now login with your new password.',
          messageType: 'success',
          submitting: false
        });
      } else {
        this.setState({ 
          message: data.message || 'Failed to reset password',
          messageType: 'error',
          submitting: false
        });
      }
    } catch (err) {
      this.setState({ 
        message: 'Something went wrong. Please try again.',
        messageType: 'error',
        submitting: false
      });
    }
  }

  render() {
    const { loading, tokenValid, newPassword, confirmPassword, submitting, message, messageType, success } = this.state;

    if (loading) {
      return (
        <Container>
          <Card>
            <Logo>
              <img src="/assets/images/lg.png" alt="bkk07" />
            </Logo>
            <Spinner />
            <Subtitle>Verifying your reset link...</Subtitle>
          </Card>
        </Container>
      );
    }

    return (
      <Container>
        <Card>
          <Logo>
            <img src="/assets/images/lg.png" alt="bkk07" />
          </Logo>
          
          {!tokenValid ? (
            <>
              <Title>Link Expired</Title>
              {message && <Message type={messageType}>{message}</Message>}
              <Subtitle>This reset link is invalid or has expired. Please request a new one.</Subtitle>
              <BackLink href="/">Go to Homepage</BackLink>
            </>
          ) : success ? (
            <>
              <Title>Password Reset!</Title>
              <Message type="success">{message}</Message>
              <BackLink href="/">Go to Login</BackLink>
            </>
          ) : (
            <>
              <Title>Set New Password</Title>
              <Subtitle>Enter your new password below</Subtitle>
              {message && <Message type={messageType}>{message}</Message>}
              <form onSubmit={this.handleSubmit}>
                <InputWrapper>
                  <Label>New Password</Label>
                  <Input
                    type="password"
                    placeholder="Enter new password"
                    value={newPassword}
                    onChange={(e) => this.setState({ newPassword: e.target.value })}
                  />
                </InputWrapper>
                <InputWrapper>
                  <Label>Confirm Password</Label>
                  <Input
                    type="password"
                    placeholder="Confirm new password"
                    value={confirmPassword}
                    onChange={(e) => this.setState({ confirmPassword: e.target.value })}
                  />
                </InputWrapper>
                <Button type="submit" disabled={submitting}>
                  {submitting ? 'Resetting...' : 'Reset Password'}
                </Button>
              </form>
              <BackLink href="/">Back to Login</BackLink>
            </>
          )}
        </Card>
      </Container>
    );
  }
}

export default ResetPassword;
